import api from '@/api/favourites';

const listFavourites = (context, data) => new Promise(((resolve, reject) => {
  api.listFavourites(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const addFavouriteLesson = (context, data) => new Promise(((resolve, reject) => {
  api.addFavouriteLesson(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const removeFavouriteLesson = (context, data) => new Promise(((resolve, reject) => {
  api.removeFavouriteLesson(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

export default {
  listFavourites,
  addFavouriteLesson,
  removeFavouriteLesson
};



// WEBPACK FOOTER //
// ./src/store/modules/favourites/actions.js